import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class ProjectContactsDAO extends DAO {

  constructor(store) {
    super(store, 'project_contact');
    this.unsetProjectContacts = this.unsetProjectContacts.bind(this);
    this.clearProjectContacts = this.clearProjectContacts.bind(this);
  }

  unsetProjectContacts(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearProjectContacts() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_project_contacts, null, this.unsetProjectContacts, this.clearProjectContacts, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/ProjectContactsDAO.js